import { useCallback, useRef, useState } from 'react';
import { createContainer } from 'unstated-next';

type StripePaymentMethodCreator = () => Promise<string | null>;

function buildCheckout() {
	const [stripeToken, setStripeToken] = useState<string | null>(null);
	const stripePaymentMethodCreator = useRef<StripePaymentMethodCreator | null>(null);

	const setStripePaymentMethodCreator = useCallback((creator: StripePaymentMethodCreator | null) => {
		stripePaymentMethodCreator.current = creator;
	}, []);

	const createStripePaymentMethod = useCallback(async () => {
		if (!stripePaymentMethodCreator.current) return null;
		return stripePaymentMethodCreator.current();
	}, []);

	const resetStripePaymentMethod = useCallback(() => {
		setStripeToken(null);
	}, []);

	return {
		stripeToken,
		setStripeToken,
		setStripePaymentMethodCreator,
		createStripePaymentMethod,
		resetStripePaymentMethod,
	};
}

export const CheckoutContainer = createContainer(buildCheckout);
